<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <h2>{{ data.title }}</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-6">
      <h3>{{ data.walkingTitle }}</h3>
    </div>
    <div class="col-6">
      <h3>{{ data.runningTitle }}</h3>
    </div>
  </div>
  <div class="row">
    <div class="col-3" *ngFor="let pdf of data.walkingLeftColumnPdfs">
      <a href="{{ pdf?.url }}" target="_blank">{{ pdf.caption }}</a>
    </div>
    <div class="col-3" *ngFor="let pdf of data.walkingRightColumnPdfs ">
      <a href="{{ pdf?.url }}" target="_blank">{{ pdf.caption }}</a>
    </div>
    <div class="col-3" *ngFor="let pdf of data.runningLeftColumnPdfs ">
      <a href="{{ pdf?.url }}" target="_blank">{{ pdf.caption }}</a>
    </div>
    <div class="col-3" *ngFor="let pdf of data.runningRightColumnPdfs">
      <a href="{{ pdf?.url }}" target="_blank">{{ pdf.caption }}</a>
    </div>
  </div>
</div>
